import { render } from "./position_item.vue?vue&type=template&id=c2f531b2"
import script from "./position_item.vue?vue&type=script&lang=js"
export * from "./position_item.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/comerc/position/position_item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2f531b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2f531b2', __exports__)) {
    console.log('reload')
    api.reload('c2f531b2', __exports__)
  }
  
  module.hot.accept("./position_item.vue?vue&type=template&id=c2f531b2", () => {
    console.log('re-render')
    api.rerender('c2f531b2', render)
  })

}


export default __exports__